import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { getFinanceMedicalFileList } from '../../../actions/MasterAction';
import CONSTANT from '../../../constant';
import { getCookie, getDateParts, getStorage } from '../../../utils';

  class EditModule extends Component {

     
    constructor(props) {
        super(props);
         
        this.state = {
            userDetail : getCookie(CONSTANT.cookie.userDetail),
            hrDealing:getStorage(CONSTANT.cookie.hrDealingOfficerList)[0],   
            hrExecutive:getStorage(CONSTANT.cookie.hrexecutive)[0],   
            finance:getStorage(CONSTANT.cookie.finance),
            updateStatus:[] ,    
            list: undefined,
            date: new Date() ,
            approvedFile:undefined
        }
    
    }


  componentDidMount(prevProps, preState , snapshot ){  
    const {finance , userDetail } = this.state
     
    let updateStatus = []
    finance.map((ele)=>{
        updateStatus.push({
             update:false,
             userCode:ele.code,
             list:undefined
        })      
    })

    getFinanceMedicalFileList().then((res) => {
              let pending = res.result.pending
              
               //pending files according to user  
              pending = pending.filter(ele=> ele.pendingWith==userDetail.code ) 
               let approvedFile = res.result.approved
               
            //   let financeMedicalFiles = pending.filter((ele)=> ele.pendingWith == userDetail.code )
            //   let approvedMedicalFiles = approvedFile.filter((ele)=> ele.pendingWith == userDetail.code)   

               
              this.setState({list:pending})
              this.setState({approvedFile:approvedFile})
            });
    
    this.setState({updateStatus:updateStatus})

  }


  openDetailPage =(pageUrl)=>{
    this.props.history.push(pageUrl)  
 }

 
    render() {
         
    const {finance , userDetail ,list , approvedFile } = this.state

    return (
      <React.Fragment>

              {
                 userDetail.code ==1785   ?
                  <div className="row">
             <div className="col-md-12 mt-3">
                 <div className="list-container">
                 <h3 class="page-title"> Requested Medicals  </h3>
                     <table className="table table-bordered table-hover" style={{wordWrap:"break-word"}}>
                         <tbody>
                             <tr>
                                 <th scope="col" style={{ width: '3%' }}>#</th>
                                 <th scope="col ">Description</th>
                                 <th scope="col">Requested by</th>
                                 <th scope="col">Modified</th>
                                 <th scope="col">Status</th>
                             </tr>
                                  {list === undefined && <tr>
                                      <td colSpan={5} className="text-center">Loading...</td>
                                  </tr>    
                               }
                              
                                 {  list !== undefined && list.length === 0 && <tr>
                                  <td colSpan={5} className="text-center">No records found</td>
                                 </tr>}

                             
                              
                             {  
                                 list !== undefined && list.map((item, index) => {
                                     const detailPageURL = CONSTANT.component.medicalClaimList.url.replace(':code', item.medicalId );
                                     const dated = getDateParts(item.modifiedBy) ;
                                      
                                        
                                     if(item.status=='false' && item.status2=='false'){
                                        return (
                                          
                                            <tr key={index} className="c-pointer"  onClick={(e) => this.openDetailPage(detailPageURL) } >
                                                <td>{index + 1}</td>
                                                <td className="text-truncate" style={{maxWidth:"50px"}} >{item.description}</td>
                                                <td>{item.requestedby}</td>
                                                <td>{`${dated.date} ${dated.monthName} ${dated.year}`}</td>
                                                 
                                                 {/*
                                                   userDetail.code==this.state.hrDealing.code?
                                                <td>{item.levelOne=="false"?<span class="badge badge-warning w-50 p-1 " >Pending </span>  : <span class="badge badge-success w-50 p-1 ">Approved</span>   }</td>
                                                  : userDetail.code==this.state.hrExecutive.code? 
                                                <td>{item.levelTwo=="false"?<span class="badge badge-warning w-50 p-1 " >Pending </span>  : <span class="badge badge-success w-50 p-1 ">Approved</span>   }</td>
                                                     :""
                                        */}

                                          <td><span class="badge badge-warning w-50 p-1 " >   { }  Pending </span></td>



                                            
                                                </tr>
                                        )
                                         


                                         
                                     }
                                      
                                       
                                     
                                 })  
                              }
                             
                         </tbody>
                     </table>
                 </div>
             </div>
         </div> :""
                  }













                  {
                     userDetail.code==1785 ?
                      <div className="row">
                 <div className="col-md-12 mt-3">
                     <div className="list-container">
                     <h3 class="page-title"> Approved Medicals </h3>
                         <table className="table table-bordered table-hover" style={{wordWrap:"break-word"}}>
                             <tbody>
                                 <tr>
                                     <th scope="col" style={{ width: '3%' }}>#</th>
                                     <th scope="col ">Description</th>
                                     <th scope="col">Requested by</th>
                                     <th scope="col">Modified</th>
                                     <th scope="col">Status</th>
                                 </tr>
                                  
                              
                                      {approvedFile === undefined && <tr>
                                          <td colSpan={5} className="text-center">Loading...</td>
                                      </tr>    
                                     }
                                  
                                     {  approvedFile !== undefined && approvedFile.length === 0 && <tr>
                                      <td colSpan={5} className="text-center">No records found</td>
                                     </tr>}
    
                                 
                                  
                                 {  
                                     approvedFile !== undefined && approvedFile.map((item, index) => {
                                         const detailPageURL = CONSTANT.component.medicalClaimList.url.replace(':code', item.medicalId );
                                         const dated = getDateParts( item.modifiedBy ) ;
                                          
                                         
                                            if( item.status=="true" ){

                                                return (
                                              
                                                    <tr key={index} className="c-pointer"  onClick={(e) => this.openDetailPage(detailPageURL) } >
                                                        <td>{index + 1}</td>
                                                        <td className="text-truncate" style={{maxWidth:"50px"}} >{item.description}</td>
                                                        <td>{item.requestedby}</td>
                                                        <td>{`${dated.date} ${dated.monthName} ${dated.year}`}</td>
                                                         
                                                         {/*
                                                           userDetail.code==this.state.hrDealing.code?
                                                        <td>{item.levelOne=="false"?<span class="badge badge-warning w-50 p-1 " >Pending </span>  : <span class="badge badge-success w-50 p-1 ">Approved</span>   }</td>
                                                          : userDetail.code==this.state.hrExecutive.code? 
                                                        <td>{item.levelTwo=="false"?<span class="badge badge-warning w-50 p-1 " >Pending </span>  : <span class="badge badge-success w-50 p-1 ">Approved</span>   }</td>
                                                             :""
                                                */}
       
                                                  <td> <span className= {item.status=="true"?"badge  badge-success w-50 p-1 ":"badge  badge-warning w-50 p-1 " }   > {item.status=="true"?"Approved":"Pending" } </span></td>                                                    
                                                        </tr>
                                                )

                                                 
                                            }
                                            
                                           
                                         
                                     })  
                                  }
                                 
                             </tbody>
                         </table>
                     </div>
                 </div>
             </div> :""
                      }

























































                      {
                        userDetail.code ==1799   ?
                         <div className="row">
                    <div className="col-md-12 mt-3">
                        <div className="list-container">
                        <h3 class="page-title"> Requested Medicals  </h3>
                            <table className="table table-bordered table-hover" style={{wordWrap:"break-word"}}>
                                <tbody>
                                    <tr>
                                        <th scope="col" style={{ width: '3%' }}>#</th>
                                        <th scope="col ">Description</th>
                                        <th scope="col">Requested by</th>
                                        <th scope="col">Modified</th>
                                        <th scope="col">Status</th>
        
                                    </tr>
                                     
                                 
                                         {list === undefined && <tr>
                                             <td colSpan={5} className="text-center">Loading...</td>
                                         </tr>    
                                      }
                                     
                                        {  list !== undefined && list.length === 0 && <tr>
                                         <td colSpan={5} className="text-center">No records found</td>
                                        </tr>}
       
                                    
                                     
                                    {  
                                        list !== undefined && list.map((item, index) => {
                                            const detailPageURL = CONSTANT.component.medicalClaimList.url.replace(':code', item.medicalId );
                                            const dated = getDateParts(item.modifiedBy) ;
                                             
                                               
                                            if(item.status=='true' && item.status2=='false'){
                                               return (
                                                 
                                                   <tr key={index} className="c-pointer"  onClick={(e) => this.openDetailPage(detailPageURL) } >
                                                       <td>{index + 1}</td>
                                                       <td className="text-truncate" style={{maxWidth:"50px"}} >{item.description}</td>
                                                       <td>{item.requestedby}</td>
                                                       <td>{`${dated.date} ${dated.monthName} ${dated.year}`}</td>
                                                        
                                                        {/*
                                                          userDetail.code==this.state.hrDealing.code?
                                                       <td>{item.levelOne=="false"?<span class="badge badge-warning w-50 p-1 " >Pending </span>  : <span class="badge badge-success w-50 p-1 ">Approved</span>   }</td>
                                                         : userDetail.code==this.state.hrExecutive.code? 
                                                       <td>{item.levelTwo=="false"?<span class="badge badge-warning w-50 p-1 " >Pending </span>  : <span class="badge badge-success w-50 p-1 ">Approved</span>   }</td>
                                                            :""
                                               */}
       
                                                 <td><span class="badge badge-warning w-50 p-1 " >   { }  Pending </span></td>
       
       
       
                                                   
                                                       </tr>
                                               )
                                                
       
       
                                                
                                            }
                                             
                                              
                                            
                                        })  
                                     }
                                    
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div> :""
                         }
       
       
       
       
       
       
       
       
       
       
       
       
       
                         {
                            userDetail.code==1799 ?
                             <div className="row">
                        <div className="col-md-12 mt-3">
                            <div className="list-container">
                            <h3 class="page-title"> Finally Approved Medicals </h3>
                                <table className="table table-bordered table-hover" style={{wordWrap:"break-word"}}>
                                    <tbody>
                                        <tr>
                                            <th scope="col" style={{ width: '3%' }}>#</th>
                                            <th scope="col ">Description</th>
                                            <th scope="col">Requested by</th>
                                            <th scope="col">Modified</th>
                                            <th scope="col">Status</th>
                                        </tr>
                                         
                                     
                                             {approvedFile === undefined && <tr>
                                                 <td colSpan={5} className="text-center">Loading...</td>
                                             </tr>    
                                            }
                                         
                                            {  approvedFile !== undefined && approvedFile.length === 0 && <tr>
                                             <td colSpan={5} className="text-center">No records found</td>
                                            </tr>}
           
                                        
                                         
                                        {  
                                            approvedFile !== undefined && approvedFile.map((item, index) => {
                                                const detailPageURL = CONSTANT.component.medicalClaimList.url.replace(':code', item.medicalId );
                                                const dated = getDateParts( item.modifiedBy ) ;
                                                 
                                                
                                                   if(item.status=="true"  && item.status2=="true"  ){
       
                                                       return (
                                                     
                                                           <tr key={index} className="c-pointer"  onClick={(e) => this.openDetailPage(detailPageURL) } >
                                                               <td>{index + 1}</td>
                                                               <td className="text-truncate" style={{maxWidth:"50px"}} >{item.description}</td>
                                                               <td>{item.requestedby}</td>
                                                               <td>{`${dated.date} ${dated.monthName} ${dated.year}`}</td>
                                                                
                                                                {/*
                                                                  userDetail.code==this.state.hrDealing.code?
                                                               <td>{item.levelOne=="false"?<span class="badge badge-warning w-50 p-1 " >Pending </span>  : <span class="badge badge-success w-50 p-1 ">Approved</span>   }</td>
                                                                 : userDetail.code==this.state.hrExecutive.code? 
                                                               <td>{item.levelTwo=="false"?<span class="badge badge-warning w-50 p-1 " >Pending </span>  : <span class="badge badge-success w-50 p-1 ">Approved</span>   }</td>
                                                                    :""
                                                       */}
              
                                                         <td> <span className= {item.status=="true"?"badge  badge-success w-50 p-1 ":"badge  badge-warning w-50 p-1 " }   > {item.status=="true"?"Approved":"Pending" } </span></td>                                                    
                                                               </tr>
                                                       )
       
                                                        
                                                   }
                                                   
                                                  
                                                
                                            })  
                                         }
                                        
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div> :""
                             }






















           
         { /*
         getStorage(CONSTANT.cookie.finance).some(ele => ele.code==userDetail.code ) && approvedFile!=undefined && approvedFile.length > 0 &&
         <div className="row">
             <div className="col-md-12 mt-3">
                 <div className="list-container">
                 <h3 class="page-title"> Finally Approved Medicals // testing </h3>
                     <table className="table table-bordered table-hover" style={{wordWrap:"break-word"}}>
                         <tbody>
                             <tr>
                                 <th scope="col" style={{ width: '3%' }}>#</th>
                                 <th scope="col ">Description</th>
                                 <th scope="col">Requested by</th>
                                 <th scope="col">Modified</th>
                                 <th scope="col">Status</th>
                             </tr>
                              
                          
                                  {list === undefined && <tr>
                                      <td colSpan={5} className="text-center">Loading...</td>
                                  </tr>    
                               }
                              
                                 {  list !== undefined && list.length === 0 && <tr>
                                  <td colSpan={5} className="text-center">No records found</td>
                                 </tr>}
 
                             {
                                 list !== undefined && list.map((item, index) => {
                                     const detailPageURL = CONSTANT.component.medicalClaimList.url.replace(':code', item.id );
                                     const dated = getDateParts(item.modifiedBy) ;
                                      
                                         return (
                                          
                                             <tr key={index} className="c-pointer"  onClick={(e) => this.openDetailPage(detailPageURL) } >
                                                 <td>{index + 1}</td>
                                                 <td className="text-truncate" style={{maxWidth:"50px"}} >{item.description}</td>
                                                 <td>{item.requestedby}</td>
                                                 <td>{`${dated.date} ${dated.monthName} ${dated.year}`}</td>
                                                  
                                                  {/*
                                                    userDetail.code==this.state.hrDealing.code?
                                                 <td>{item.levelOne=="false"?<span class="badge badge-warning w-50 p-1 " >Pending </span>  : <span class="badge badge-success w-50 p-1 ">Approved</span>   }</td>
                                                   : userDetail.code==this.state.hrExecutive.code? 
                                                 <td>{item.levelTwo=="false"?<span class="badge badge-warning w-50 p-1 " >Pending </span>  : <span class="badge badge-success w-50 p-1 ">Approved</span>   }</td>
                                                      :""
                                                }

                                           <td><span class="badge badge-warning w-50 p-1 " >Pending </span></td>    
                                                 </tr>
                                         )
                                          

                                 })  
                              }
                             
                         </tbody>
                     </table>
                 </div>
             </div>
         </div>    
        
                            */}

             
      </React.Fragment>
    );
  

 
}





}


export default  withRouter(EditModule)